<template>
<div>
    <div class="d-flex justify-content-center">
      <div id="table-main-pre">
        <div class="table-head-cus d-flex justify-content-around">
            <p class="tr-cus text-center">Despesa</p>
            <p class="tr-cus text-center">Quantidade</p>
            <p class="tr-cus text-center">Valor Unitario</p>
            <p class="tr-cus text-center">Valor total</p>
            <p class="trash-class"><i class="fas fa-trash" style="visibility: hidden"></i></p>
        </div>
         <div v-for="dataType in formData" :key="dataType.id" class="table-head-cus d-flex justify-content-around">
            <p class="tr-cus pt-3">
               <select @change="veirifcarSelect" :id="'select-' + dataType.id" v-model="dataType.despesa" class="form-control">
                  <option :value="null">Selecione</option>
                  <option v-for="data in getDespesaNotSelect" :key="data.id" :value="data.id">{{data.nome}}</option>
               </select>
            </p>
            <p class="tr-cus pt-3 text-center"><input class="form-control" type="number" :id="dataType.id" disabled v-model="dataType.quantidade" @change="calcular()"></p>
            <p class="tr-cus pt-3 text-center" ><money class="form-control form-control-10 text-right text-bold"
              v-bind="moneyFormat"
              :id="'money-' +dataType.id"
              placeholder="R$ 0,00"
              @change.native="calcular"
              :disabled="true"
              prefix="R$ "
              v-model="dataType.valorUni"
              /></p>
            <p class="tr-cus pt-3 text-center"><money class="form-control form-control-10 text-right text-bold"
              v-bind="moneyFormat"
              :id="'total-'+dataType.id"
              placeholder="R$ 0,00"
              prefix="R$ "
              v-model="dataType.valorTotal"
              :disabled="true"/></p>
            <p class="trash-class text-center"><i :id="dataType.id" @click="remove" class="fas fa-trash"></i></p>
        </div>
        <div class="d-flex justify-content-center  ">
             <p @click="AddDespesas" class="newDes pt-3">+ Adicionar Despesa</p>
        </div>
      </div>
  </div>
  <div class="d-flex justify-content-center">
    <div class="footer-table">
      Total: {{total}}
    </div>
  </div>
</div>
</template>

<script>
import PredictionModal from './PredictionModal'
export default PredictionModal
</script>

<style scoped>
 #table-main-pre{
    width: 80%;
    overflow: auto;
    border: 1px solid rgb(129, 129, 129);
    border-radius: 10px 10px 0 0;
    height: 400px;
    padding-top: 15px;
 }
 .tr-cus{
    font-size: 15px;
    min-width: 150px;
    max-width: 150px;
    font-weight: bold;
 }
 .table-head-cus{
    border-bottom: 1px solid rgb(129, 129, 129);
 }
 .newDes{
    color: #025e33;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
 }
 .footer-table{
    height: 40px;
    width: 80%;
    display: flex;
    font-size: 18px;
    padding-right: 15px;
    font-weight: bold;
    justify-content: end;
    align-items: center;
    border-bottom: 1px solid rgb(129, 129, 129);
    border-left: 1px solid rgb(129, 129, 129);
    border-right: 1px solid rgb(129, 129, 129);
    border-radius: 0 0 10px 10px;

 }
 .trash-class{
   display: flex;
   justify-content: center;
   align-items: center;
   font-size: 20px;
   cursor: pointer;
 }
 .trash-class:hover{
   color: red;
 }
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/PredictionModal/PredictionModal.vue